import AstraLayout from './AstraLayout';

export default AstraLayout;
